// extracted by mini-css-extract-plugin
var _1 = "Layout-module__layoutContainer__QHaqU";
var _2 = "Layout-module__layoutWrapper__S1shf";
var _3 = "Layout-module__mainContent__qPWNl";
var _4 = "Layout-module__mainPanel__ntJpR";
export { _1 as "layoutContainer", _2 as "layoutWrapper", _3 as "mainContent", _4 as "mainPanel" }
